export const AUTHORIZATION_CHECK_REQUEST = "AUTHORIZATION_CHECK_REQUEST";
export const AUTHORIZATION_CHECK_SUCCESS = "AUTHORIZATION_CHECK_SUCCESS";
export const AUTHORIZATION_CHECK_FAILURE = "AUTHORIZATION_CHECK_FAILURE";

export const LOAD_CHECKINS_REQUEST = `LOAD_CHECKINS_REQUEST`;
export const LOAD_CHECKINS_SUCCESS = `LOAD_CHECKINS_SUCCESS`;
export const LOAD_CHECKINS_FAILURE = `LOAD_CHECKINS_FAILURE`;

export const SET_CHECKIN_REQUEST = `SET_CHECKIN_REQUEST`;
export const SET_CHECKIN_SUCCESS = `SET_CHECKIN_SUCCESS`;
export const SET_CHECKIN_FAILURE = `SET_CHECKIN_FAILURE`;

export const SET_NOSHOW_REQUEST = `SET_NOSHOW_REQUEST`;
export const SET_NOSHOW_SUCCESS = `SET_NOSHOW_SUCCESS`;
export const SET_NOSHOW_FAILURE = `SET_NOSHOW_FAILURE`;

export const SET_WAIVER_FORM_SUBMITTED_REQUEST = `SET_WAIVER_FORM_SUBMITTED_REQUEST`;
export const SET_WAIVER_FORM_SUBMITTED_SUCCESS = `SET_WAIVER_FORM_SUBMITTED_SUCCESS`;
export const SET_WAIVER_FORM_SUBMITTED_FAILURE = `SET_WAIVER_FORM_SUBMITTED_FAILURE`;

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const SET_ACTIVE_PAGE_TITLE = "SET_ACTIVE_PAGE_TITLE";

export const LOAD_PRODUCTS_REQUEST = "LOAD_PRODUCTS_REQUEST";
export const LOAD_PRODUCTS_SUCCESS = "LOAD_PRODUCTS_SUCCESS";
export const LOAD_PRODUCTS_FAILURE = "LOAD_PRODUCTS_FAILURE";

export const LOAD_PURCHASES_REQUEST = "LOAD_PURCHASES_REQUEST";
export const LOAD_PURCHASES_SUCCESS = "LOAD_PURCHASES_SUCCESS";
export const LOAD_PURCHASES_FAILURE = "LOAD_PURCHASES_FAILURE";

export const LOAD_CUSTOMERS_REQUEST = "LOAD_CUSTOMERS_REQUEST";
export const LOAD_CUSTOMERS_SUCCESS = "LOAD_CUSTOMERS_SUCCESS";
export const LOAD_CUSTOMERS_FAILURE = "LOAD_CUSTOMERS_FAILURE";

export const LOAD_USERS_REQUEST = "LOAD_USERS_REQUEST";
export const LOAD_USERS_SUCCESS = "LOAD_USERS_SUCCESS";
export const LOAD_USERS_FAILURE = "LOAD_USERS_FAILURE";

export const ADD_PURCHASE_REQUEST = "ADD_PURCHASE_REQUEST";
export const ADD_PURCHASE_SUCCESS = "ADD_PURCHASE_SUCCESS";
export const ADD_PURCHASE_FAILURE = "ADD_PURCHASE_FAILURE";
export const ADD_PURCHASE_RESET = "ADD_PURCHASE_RESET";

export const LOAD_PRODUCT_TOUR_PRICING_SUCCESS =
  "LOAD_PRODUCT_TOUR_PRICING_SUCCESS";
export const LOAD_PRODUCT_TOUR_PRICING_FAILURE =
  "LOAD_PRODUCT_TOUR_PRICING_FAILURE";

export const LOAD_CUSTOMER_COMISSION_SUCCESS =
  "LOAD_CUSTOMER_COMISSION_SUCCESS";
export const LOAD_CUSTOMER_COMISSION_FAILURE =
  "LOAD_CUSTOMER_COMISSION_FAILURE";

export const GET_PAYMENT_HISTORY_REQUEST = "GET_PAYMENT_HISTORY_REQUEST";
export const GET_PAYMENT_HISTORY_SUCCESS = "GET_PAYMENT_HISTORY_SUCCESS";
export const GET_PAYMENT_HISTORY_FAILURE = "GET_PAYMENT_HISTORY_FAILURE";
export const GET_PAYMENT_HISTORY_RESET = "GET_PAYMENT_HISTORY_RESET";

export const ADD_PAYMENT_REQUEST = "ADD_PAYMENT_REQUEST";
export const ADD_PAYMENT_SUCCESS = "ADD_PAYMENT_SUCCESS";
export const ADD_PAYMENT_FAILURE = "ADD_PAYMENT_FAILURE";
export const ADD_PAYMENT_RESET = "ADD_PAYMENT_RESET";

export const ADD_REFUND_REQUEST = "ADD_REFUND_REQUEST";
export const ADD_REFUND_SUCCESS = "ADD_REFUND_SUCCESS";
export const ADD_REFUND_FAILURE = "ADD_REFUND_FAILURE";
export const ADD_REFUND_RESET = "ADD_REFUND_RESET";

export const DELETE_CHARGE_REQUEST = "DELETE_CHARGE_REQUEST";
export const DELETE_CHARGE_SUCCESS = "DELETE_CHARGE_SUCCESS";
export const DELETE_CHARGE_FAILURE = "DELETE_CHARGE_FAILURE";
export const DELETE_CHARGE_RESET = "DELETE_CHARGE_RESET";

export const CLEAR_ALL_NOTIFICATIONS_AND_ERRORS =
  "CLEAR_ALL_NOTIFICATIONS_AND_ERRORS";
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const SHOW_ERROR = "SHOW_ERROR";



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/